export default __webpack_public_path__ + "static/media/2.58a7a458.svg";